const binding = { modules: {}, dataActions: {} };

    (binding.modules['moe-article-list-item'] = {
        c: () => require('partner/modules/moe-article-list-item/moe-article-list-item.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'moe-article-list-item',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/moe-article-list-item'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|moe-article-list-item|moe-article-list-item'] = {
                c: () => require('partner/modules/moe-article-list-item/moe-article-list-item.view.tsx'),
                cn: '__local__-__local__-moe-article-list-item'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };